import { createSelector } from 'reselect';

import { SessionStorageKeys } from '~/components/brand/constants';

import NS from './reducer-name';
import { isNativeGameplayHeaderEnabled } from '~/components/app-bridge/app-properties';

// FIXME and remove after migration
/// const TEMPLATE_OVERRIDE = process.env.TEMPLATE || '';

export const selectCurrencies = state => state[NS].currencies;
export const selectLicense = state => state[NS].license;
export const selectIsDesktop = state => state[NS].isDesktop;
export const selectGermanProductSwitchEnabled = state => state[NS].isGermanProductSwitchEnabled;
export const selectOntarioFranchise = state => state[NS].isOntarioRegulatedFranchise;
export const selectNetherlandsFranchise = state => state[NS].isNetherlandsRegulatedFranchise;
export const selectIsGermanRegulatedFranchise = state => state[NS].isGermanRegulatedFranchise;
export const selectIsCanadianFranchise = state => state[NS].isCanadianFranchise;

export const selectSiteCode = state => state[NS].siteCode;
export const selectBrandName = state => state[NS].brandName;
export const selectDefaultProduct = state => state[NS].defaultProduct;
export const selectBlackFridayCampaignEnabled = state => state[NS].blackFridayCampaignEnabled;
export const selectSiteType = state => state[NS].siteType;
export const selectProposedLocale = state => state[NS].proposedLocale;
export const selectDisableProposedLocaleForFranchise = state => state[NS].disableProposedLocaleForFranchise;
export const selectBrand = state => state[NS];
export const selectDefaultLocale = state => state[NS].defaultLocale;
export const selectCurrentUrlLang = state => state[NS].currentUrlLang;
export const selectHtmlLang = state => state[NS].htmlLang;
export const selectShowMentorMessages = state => state[NS].showMentorMessages;
export const selectSiteId = state => state[NS].siteId;
export const selectFranchiseId = state => state[NS].franchiseId;
export const selectFranchiseCode = state => state[NS].franchiseCode;
export const selectEnableAddOnScript = state => state[NS].enableAddOnScript;
export const selectFranchiseName = state => state[NS].franchiseName;
export const selectPolishFranchise = state => state[NS].isPolishFranchise;
export const selectIsGuestPlayer = state => state[NS].isGuestPlayer;
export const selectGuestLocale = state => state[NS].guestLocale;
export const selectIsDefaultFranchiseLanguageSelected = state => {
	return state[NS].locales && state[NS].locales.some(locale => locale.defaultFranchiseLocale && locale.checked);
};

export const selectShowNewCookieBanner = state => state[NS].showNewCookieBanner;
export const selectTvBetScriptUrl = state => state[NS].tvBetScriptUrl;
export const selectTvBetMobileGameCode = state => state[NS].tvBetMobileGameCode;
export const selectTvBetDesktopGameCode = state => state[NS].tvBetDesktopGameCode;
// export const selectTemplate = state => TEMPLATE_OVERRIDE || state[NS].template;
export const selectShowTrustLogos = state => state[NS].showTrustLogos;

export const selectProducts = state => state[NS].products;
export const selectMainContentLoading = state => state[NS].mainContentLoading;
export const selectExpandTermsAndDescriptions = state => state[NS].expandTermsAndDescriptions;

export const selectQuickDepositMobile = state => state[NS].enableMobileQuickDeposit;

export const selectMobileIngameToolbar = state =>
	state[NS].enableMobileIngameToolbar && !isNativeGameplayHeaderEnabled();

export const selectNavbarMenu = state => state[NS].menu.navbar;
export const selectLandingpageMenu = state => state[NS].menu.landingPage;

export const selectVirtualsInspiredEnabled = state => state[NS].virtualsInspiredEnabled;
export const selectVirtualsHighlightGamesEnabled = state => state[NS].virtualsHighlightGamesEnabled;

export const selectHasProducts = createSelector(selectProducts, products => ({
	hasSportsbook: products.includes('sportsbook'),
	hasLivebetting: products.includes('live-betting'),
	hasVirtuals: products.includes('virtuals'),
	hasCasino: products.includes('casino'),
	hasLivecasino: products.includes('livecasino'),
	hasWeSpin: products.includes('we-spin'),
	hasTvBet: products.includes('tvbet')
}));

export const selectCasinoMaintenanceEnabled = state => state[NS].casinoMaintenanceEnabled;

export const selectCasinoHeartbeatUrl = state => state[NS].casinoHeartbeatUrl;
export const selectCasinoEndHeartbeatUrl = state => state[NS].casinoEndHeartbeatUrl;
export const selectCasinoHeartbeatInterval = state => state[NS].casinoHeartbeatInterval;

export const selectCasinoFiltersEnabled = () => false;
export const selectLiveCasinoFiltersEnabled = state =>
	state[NS].enableLiveCasinoFilters || sessionStorage.getItem(SessionStorageKeys.ENABLE_LC3_FEATURE) === 'true';

const selectCasinoFilterAmountCurrencies = state => state[NS].casinoFilterAmountCurrencies;
export const selectActiveCurrency = (_, currency) => currency;

export const selectCasinoFilterAmounts = createSelector(
	[selectCasinoFilterAmountCurrencies, state => state, selectActiveCurrency],
	(currencies, state, activeCurrency) => {
		// we retrieve the currencies as a comma seperated string thus splitting into an array
		const amountCurrenciesArray = currencies?.split(',');
		const isActiveCurrencyListedInAmounts = amountCurrenciesArray?.some(currency => currency === activeCurrency);

		if (isActiveCurrencyListedInAmounts) {
			const amountRanges = state[NS][`casinoFilterAmountRanges_${activeCurrency}`].split(',');
			const highestRange = amountRanges?.at(-1);
			const highestAmount = highestRange?.match(/\d+$/i);

			if (amountRanges?.length) {
				return amountRanges.concat(highestAmount);
			}
		}

		return null;
	}
);

export const selectEnableNewInput = state => state[NS].enableNewInput;

export const selectShowBannerTermsAndCondition = state => state[NS].showBannerTermsAndCondition;
export const selectBannerTermsAndConditionText = state => state[NS].bannerTermsAndConditionText;

export const selectEnableBannerService = state => state[NS].enableBannerService;

export const selectEnableInhouseJackpot = state => state[NS].enableInhouseJackpot;
export const selectInhouseJackpotIconUrl = state => state[NS].inhouseJackpotOptinIconUrl;
export const selectEnableBeyondPlayJackpot = state => state[NS].enableBeyondPlayJackpot;
export const selectEnableSplashJackpot = state => state[NS].enableSplashJackpot;

export const selectEnableTournamentService = state => state[NS].enableTournamentService;

export const selectEnableLiveCasino3 = state =>
	state[NS].enableLiveCasino3 || sessionStorage.getItem(SessionStorageKeys.ENABLE_LC3_FEATURE) === 'true';
export const selectEnableCasinoMultiGame = state => state[NS].enableCasinoMultiGame;
export const selectEnableLiveCasinoMultiGame = state => state[NS].enableLiveCasinoMultiGame;
export const selectGameInfoSlotsDataEnabled = state => state[NS].gameInfoSlotsDataEnabled;
export const selectEnableQuickFiltersSubproviders = state => state[NS].enableQuickFiltersSubproviders;

export const selectShowDropsWinsPragmatic = state => state[NS].showDropsWinsPragmatic;

export const selectCasinoSubMenuItems = state => state[NS].casinoSubmenuItems;

export const selectEnableLocationSmart = state => state[NS].enableLocationSmart;

export const selectIsBotRequest = state => state[NS].isBotRequest;

export const selectSiteHostname = state => state[NS].siteHostname;

export const selectJapanFranchise = state => state[NS].isJapanFranchise;
export const selectGlobalFranchise = state => state[NS].isGlobalFranchise;

export const selectWebPushEnabled = state => state[NS].webPushEnabled;
export const selectWebPushTriggerSuccessDeposit = state => state[NS].webPushTriggerSuccessDeposit;
export const selectWebPushTriggerWithdrawRequest = state => state[NS].webPushTriggerWithdrawRequest;
export const selectWebPushTriggerWeSpinSuccess = state => state[NS].webPushTriggerWeSpinSuccess;

export const selectMyNotificationsEnabled = state => state[NS].myNotificationsEnabled;
export const selectSystemMessageEnabled = state => state[NS].systemMessageEnabled;
export const selectSystemMessage = state => state[NS].systemMessage;

export const isDanishFranchise = state => state[NS].isDanishFranchise;

export const IsGermanRegulatedFranchise = state => state[NS].isGermanRegulatedFranchise;

export const selectIsNetherlandsRegulatedFranchise = state => state[NS].isNetherlandsRegulatedFranchise;

export const selectSwedishRegulatedFranchise = state => state[NS].isSwedishRegulatedFranchise;

export const selectAuthResGamingLimit = state => state[NS].isOntarioRegulatedFranchise; // remove this late on

export const selectRCWebSocket = state => state[NS].enableRCWebSocket;

export const selectSupport = state => state.support;

export const selectUseCustomLogos = state => state[NS].useCustomLogos;
export const selectIsRealityCheckEnabled = state => state[NS].isRealityCheckEnabled;

export const selectPreloadTournamentsCategory = state => state[NS].preloadTournamentsCategory;
export const selectGraphyteSearchEnabled = state => state[NS].graphyteSearchEnabled;

export const selectLimitNotificationDismissTime = state => state[NS].limitNotificationDismissTime;
export const selectTrustlyLoginPollTime = state => state[NS].trustlyLoginPollTime;
export const selectVerifyEmail = state => state[NS].verifyEmail;
export const selectDoEmailVerification = state => state[NS].doEmailVerification;

export const selectLocales = state => state[NS].locales;
export const selectIsoCodeForLocale = createSelector(
	selectLocales,
	locales => locales.find(item => item.checked).isoCode
);
export const selectLangNameForLocale = createSelector(
	selectLocales,
	locales => locales.find(item => item.checked).langName
);
export const selectLocale = createSelector(selectLocales, locales => locales.find(item => item.checked).locale);
export const selectLocaleObject = createSelector(selectLocales, locales => locales.find(item => item.checked));

export const selectBankIdDepositDetails = state => state[NS].bankIdDepositDetails;
export const selectLanguageProductSEOMap = state => state[NS].languageProductSEOMap;

export const selectNavigation = state => state[NS].navigation;

export const selectLastProduct = state => state[NS].lastProduct;

export const selectEnableCSAButtonInMobileVerify = state => state[NS].enableCSAButtonInMobileVerify;

// TODO: cleanup
export const selectEnabledSupportForFailedDeposit = state => state[NS].enableSupportForFailedDeposit;
export const selectSuggestedAmounts = state => state[NS].suggestedAmounts;
export const selectDefaultDepositLoginAmount = state => state[NS].defaultDepositLoginAmount;
